<template>
  <div>
    <div v-if="this.initializing">
      <px-circular-loading/>
    </div>
    <template v-if="!initializing">
      <px-view-header title="Quadro comparativo" title-class="font-weight-bold"/>
      <px-matriz-resposta-filters :selected-cotacoes="selectedCotacoes" @change="onChangeFilter"/>
      <div v-if="hasViewType && !hasCotacoes"
           align="center"
           class="headline mt-10 mb-10">
        É necessário selecionar uma cotação
      </div>
      <div v-if="!hasViewType"
           align="center"
           class="headline mt-10 mb-10">
        É necessário selecionar o modo de visualização
      </div>
      <px-matriz class="mt-5" ref="pxMatriz" v-if="hasViewType && hasCotacoes"/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CotacaoService from '@/modules/cotacao/cotacao-service';
import { CLEAR_ACTION } from '@/store/matriz/actions.type';
import MatrizRespostaFilters from './MatrizRespostaFilters.vue';
import PxMatriz from './PxMatriz.vue';

export default {
  data() {
    return {
      initializing: false,
      cotacoesQuery: this.$route.query.q,
      selectedCotacoes: null,
    };
  },
  computed: {
    ...mapGetters('matriz', ['cotacoes', 'selectedStatus', 'viewType']),
    hasViewType() {
      return this.viewType && this.viewType.length;
    },
    hasCotacoes() {
      return this.cotacoes && this.cotacoes.length;
    },
  },
  methods: {
    ...mapActions('matriz', {
      clear: CLEAR_ACTION,
    }),
    onChangeFilter() {
      this.$refs.pxMatriz.updateRespostas();
    },
    getCotacoesSelecionadas() {
      if (!this.cotacoesQuery) {
        return;
      }
      this.initializing = true;
      CotacaoService.getCotacoesList({ query: `id in (${this.cotacoesQuery})` })
        .then(({ data }) => {
          this.selectedCotacoes = data;
        })
        .finally(() => {
          this.clear();
          this.initializing = false;
        });
    },
  },
  created() {
    this.getCotacoesSelecionadas();
  },
  components: {
    pxMatrizRespostaFilters: MatrizRespostaFilters,
    PxMatriz,
  },
};
</script>
